import { GroupStatMetricNames } from "api/applications";

export const MetricBadge = ({
  metricType
}: {
  metricType: GroupStatMetricNames;
}) => {
  switch (metricType) {
    case GroupStatMetricNames.GrossIncome:
    case GroupStatMetricNames.NetIncome:
    case GroupStatMetricNames.GrossIncomeToRentRatio:
    case GroupStatMetricNames.NetIncomeToRentRatio:
    case GroupStatMetricNames.DebtToGrossIncome:
    case GroupStatMetricNames.DebtToNetIncome:
      return (
        <div className="text-xs font-medium rounded-full px-2 py-0.5 bg-success-50 text-success-700">
          Verified
        </div>
      );
    case GroupStatMetricNames.SelfReportedGrossIncome:
    case GroupStatMetricNames.SelfReportedGrossIncomeToRent:
    case GroupStatMetricNames.DebtToSelfReportedGrossIncome:
      return (
        <div className="text-xs font-medium rounded-full px-2 py-0.5 bg-alpha-40 text-content-70">
          Self-reported
        </div>
      );
    default:
      return null;
  }
};
